export interface SidenavFooterItem {
    text?: string;
    icon?: string;
    route?: string;
}
